import { FormEvent, useEffect, useState } from "react";
import { Alert, Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import { DataHandler } from "../dataHandler";
import LogoHeader from "../logoHeader/logoHeader";
import { RechnungDataFromDB } from "../listeRechnung/rechnungData";


function Rechnung() {
    const classNameCheck = 'sm-6';
    const classNameWork = 'xs-3';


    const inputTextRowsXs = "auto";

    const navigate = useNavigate();


    const { id } = useParams();
    let idNumber = -1;
    if (id)
        idNumber = parseInt(id);

    const [validated, setValidated] = useState(false);
    const [failed, setFailed] = useState<string | undefined>();
    const [success, setSuccess] = useState<string | undefined>();
    //true is loading
    const [formDataLoadingRunning, setFormDataLoadingRunning] = useState(false);
    const [loadedFormData, setLoadedFormData] = useState<RechnungDataFromDB>();



    useEffect(() => {
        if (idNumber > 0 && formDataLoadingRunning === false) {
            setFormDataLoadingRunning(true); // Loading
            const promise = DataHandler.getRechnung(idNumber);
            promise.then((data) => {
                setLoadedFormData(data);
            }).catch((error) => {
                handleDataError(error, "Lieferschein konnte nicht geladen werden.")
            });
        }
    }, []);



    const abbrechen = () => {
        navigate("/");
    }

    const clearForm = () => {
        setFormDataLoadingRunning(false);
        setLoadedFormData(undefined);
    }

    const handleDataError = (error: any, defaultmessage: string) => {
        debugger;
        if (error.message)
            defaultmessage = error.message;
        if (error.response?.data)
            defaultmessage += '\r\n ' + error.response.data;

        setFailed(defaultmessage);
    }

    const submit = (eventArgs: FormEvent) => {
        eventArgs.preventDefault();
        eventArgs.stopPropagation();
        const form = eventArgs.target as HTMLFormElement;
        let valid = form.checkValidity();
        setValidated(true);


        if (valid) {

            const data = new FormData(form);


            const done = (data: any) => {
                if (data.status === 200) {
                    clearForm();
                    navigate("/lsrg")
                    setSuccess("Rechnung gespeichert");
                }
            };
            const failed = (error: any) => {
                const message = "Fehler beim Speichern der Rechnung.";
                handleDataError(error, message);

            };

            DataHandler.sendRechnung(data, done, failed);


        }
        else {
            debugger;
            const firstInvalidElement = form.querySelector(':invalid');
            if (firstInvalidElement)
                firstInvalidElement.scrollIntoView();
        }


    }
    let failedHtml;
    if (failed) {
        failedHtml = <Modal show={failed !== undefined}><Modal.Body><Alert key='danger' variant='danger'>
            Fehler: {failed}
        </Alert>
        </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => { setFailed(undefined) }} >OK</Button>
            </Modal.Footer>
        </Modal>
    }


    let successHtml;
    if (success) {
        successHtml = <Modal show={success !== undefined}><Modal.Body><Alert key='info' variant='info'>
            {success}
        </Alert>
        </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => { setSuccess(undefined) }} >OK</Button>
            </Modal.Footer>
        </Modal>
    }

    let formdata: RechnungDataFromDB | null;
    if (loadedFormData === undefined)
        formdata = null;
    else
        formdata = loadedFormData;


    const downloadImage = (id:number)=>{
        if (!formdata)
            return;
        DataHandler.downloadImage(formdata.id, id);
    }

    return (
        <div className="lieferschein">
            {failedHtml}
            {successHtml}
            <Container fluid >
                <LogoHeader />
                <Row s>
                    <Col xs="12" sm="5">
                        <Form noValidate validated={validated} onSubmit={submit}>
                            <Row>
                                <Col>
                                    <h1>Rechnung</h1>
                                </Col>
                            </Row>

                            <input type={"hidden"} name="id" value={formdata?.id} />

                            <hr></hr>
                            <Row xs={inputTextRowsXs}>
                                <h3>Datum:</h3>
                            </Row>
                            <Row xs={inputTextRowsXs}>
                                <Form.Group>
                                    <Form.Control defaultValue={formdata?.json.date || new Date().toISOString().substring(0, 10)} required type="date" name="date"></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        Datum muss angegeben werden.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>

                            <hr></hr>
                            <Row xs={inputTextRowsXs}>
                                <h3>Beschreibung:</h3>
                            </Row>
                            <Row xs={12}>
                                <Form.Group>
                                    <Form.Control defaultValue={formdata?.json.beschreibung} as="textarea" name="beschreibung"></Form.Control>
                                </Form.Group>
                            </Row>

                            <hr></hr>
                            <Row xs={inputTextRowsXs}>
                                <h3>Techniker:</h3>
                            </Row>
                            <Row xs={inputTextRowsXs}>
                                <Form.Select name="techniker" value={formdata?.json.techniker} required>
                                    <option value="matthias">Matthias Heis +43 660 2020 005</option>
                                    <option value="simon">Simon Schneider +43 660 2020 003</option>
                                    <option value="patrick">Patick Enser +43 660 4148534</option>
                                </Form.Select>
                            </Row>
                            <hr />
                        

                            <hr />
                            <Row>
                                <Col>
                                    <h3>Fotos</h3>
                                </Col>
                            </Row>
                            {idNumber > -1 && formdata?.json.bild1 && <Row>
                                <Col xs={12}>
                                    <Button variant="info" onClick={()=>downloadImage(0)} >Bild 1 anzeigen</Button>
                                </Col>
                            </Row>}
                            {idNumber > -1 && formdata?.json.bild2 && <Row>
                                <Col xs={12}>
                                    <Button variant="info" onClick={()=>downloadImage(1)} >Bild 2 anzeigen</Button>
                                </Col>
                            </Row>}
                            {idNumber > -1 && formdata?.json.bild3 && <Row>
                                <Col xs={12}>
                                    <Button variant="info" onClick={()=>downloadImage(2)} >Bild 3 anzeigen</Button>
                                </Col>
                            </Row>}
                            {idNumber === -1 && <> <Row>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Bild 1</Form.Label>
                                        <Form.Control type="file" name="bild1" required></Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group>
                                            <Form.Label>Bild 2</Form.Label>
                                            <Form.Control type="file" name="bild2"></Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group>
                                            <Form.Label>Bild 3</Form.Label>
                                            <Form.Control type="file" name="bild3"></Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row></>}

                            <Row className="gy-5">
                                {idNumber === -1 && <Col xs={6} >
                                    <Form.Group>
                                        <div style={{ paddingTop: '1em' }}>
                                            <Button variant="primary" type="submit">Anlegen</Button>
                                        </div>
                                    </Form.Group>
                                </Col>}
                                <Col xs={6} >
                                    <div style={{ paddingTop: '1em' }}>
                                        <Button variant="secondary" type="button" onClick={abbrechen}>{idNumber === -1 ? 'Abbrechen' : 'Schließen'}</Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <Row>
                    <LogoHeader />
                </Row>
            </Container>
        </div>
    )
}

export default Rechnung;